import(/* webpackMode: "eager", webpackExports: ["ForgotPassword"] */ "/vercel/path0/apps/main-app/src/app/auth/forgot-password/components/ForgotPassword.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
